import LoginIcon from '@mui/icons-material/Login';
import { Box, Button, Stack, Typography } from '@mui/material';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import React from 'react';
import { ICalendarEvent } from '../Interfaces/Calendar/ICalendarEvent';
import { useFetch } from '../hooks/useFetch';
import { ISetting } from '../Interfaces/ISignature';

interface IProps {
  userId: number;
  refetchCalendarEvents: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<ICalendarEvent[], Error>>;
}

export const LoginPrompt: React.FC<IProps> = ({
  userId,
  refetchCalendarEvents,
}) => {
  const [settingObject, setSettingObject, wasSuccessfully] = useFetch<ISetting>(
    '/setting/',
    60
  );
  const onLogin = async () => {
    if (!settingObject) {
      console.error('Das Setting-Objekt wurde noch nicht geladen.');
      return;
    }
    // Open Popup
    const authUrl = `${settingObject.SettingValue}/api/calendar/authorize/${userId}`;

    const popup = window.open(
      authUrl,
      'Microsoft Login',
      'width=500,height=600,scrollbars=yes'
    );

    // Close Popup when calendar events are successfully fetched
    while (popup && !popup.closed) {
      const calendarEvents = await refetchCalendarEvents();
      if (calendarEvents && calendarEvents.data !== undefined) {
        popup.close();
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Stack
        sx={{
          width: 300,
          border: 1,
          borderColor: 'grey.300',
          borderRadius: 1,
          p: 2,
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Typography variant='h6' component='h1'>
          Anmeldung erforderlich
        </Typography>

        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ textAlign: 'center' }}
        >
          Bitte melden Sie sich mit Ihrem Microsoft-Konto an, um fortzufahren.
        </Typography>

        <Button variant='contained' startIcon={<LoginIcon />} onClick={onLogin}>
          Microsoft-Anmeldung
        </Button>
      </Stack>
    </Box>
  );
};
